const ThreeDotOutlined = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' fill='none' viewBox='0 0 14 14'>
    <path
      fill='#000000'
      d='M7.012 3.208a.877.877 0 0 1-.878-.875c0-.484.389-.875.872-.875h.006a.875.875 0 1 1 0 1.75M7.887 7a.875.875 0 0 0-.875-.875h-.006A.87.87 0 0 0 6.134 7a.877.877 0 0 0 1.753 0m0 4.666a.875.875 0 0 0-.875-.875h-.006a.873.873 0 0 0-.872.875.877.877 0 0 0 1.753 0'
    />
  </svg>
);

export default ThreeDotOutlined;
